import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthStore, GatewayFirmwareUpdateStore, GatewayStore } from '@store';
import { GatewayFirmwareUpdateStatus } from '@vi-iot/client/index';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'gateway-firmware-update-button',
  templateUrl: './gateway-firmware-update-button.component.html',
  styleUrls: ['./gateway-firmware-update-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GatewayFirmwareUpdateButtonComponent implements OnInit, OnDestroy {
  readonly updateStatusEnum = GatewayFirmwareUpdateStatus;
  isRsaUser: Boolean = false;
  ngUnsubscribe$: Subject<void> = new Subject<void>();

  @Input() gatewaySerial: string;
  @Input() installationId: number;

  constructor(
    public gatewayFirmwareUpdateStore: GatewayFirmwareUpdateStore,
    public gatewayStore: GatewayStore,
    private authStore: AuthStore
  ) {}

  ngOnInit(): void {
    this.setIsRsaUser();
    this.gatewayStore
      .getGatewayFirmwareUpdateStatus()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((status) => {
        if (
          status === this.updateStatusEnum.DOWNLOADING ||
          status === this.updateStatusEnum.REBOOTING
        ) {
          this.gatewayFirmwareUpdateStore.updateInProgress();
        }
      });
  }

  private setIsRsaUser(): void {
    this.authStore
      .isRsaUser()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((isRsa) => (this.isRsaUser = isRsa));
  }

  startFirmwareUpdateProcess(): void {
    this.gatewayFirmwareUpdateStore.updateFirmwareProcessStart(
      this.installationId,
      this.gatewaySerial
    );
    this.gatewayFirmwareUpdateStore.updateInProgress();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
